<template>
  <div v-loading.fullscreen.lock="isLoading">
    <div style="margin-left: 7em; margin-right: 7em">
      <el-form ref="form" :model="addForm">
        <el-row>
          <el-form-item
            label="學程"
            required
            style="margin-bottom: -1em"
          ></el-form-item>
          <el-select
            :disabled="id"
            v-model="addForm.studyClass"
            placeholder="請選擇學程"
            style="display: block; width: 100%; margin-bottom: 1em"
          >
            <el-option
              v-for="item in studyClass"
              :key="item.id"
              :label="item.studyName"
              :value="item.id"
              :disabled="item.disabled"
            >
            </el-option>
          </el-select>

          <el-form-item
            label="補考成績項目"
            style="margin-bottom: -1em"
          ></el-form-item>

          <el-row style="margin-top: 20px">
            <el-col :span="12">
               <el-checkbox
                label="背書"
                v-model="addForm.recite"
                @change="switchChange('recite')"
              ></el-checkbox>
            </el-col>
            <el-col :span="12">
              <el-date-picker
                placeholder="背書補考日期"
                :disabled="!addForm.recite"
                v-model="addForm.reciteDate"
                value-format="timestamp"
                type="date"
                style="width: 90%"
              >
              </el-date-picker>
            </el-col>
          </el-row>

          <el-row style="margin-top: 20px">
            <el-col :span="12">
              <el-checkbox
                label="辯論"
                v-model="addForm.debate"
                @change="switchChange('debate')"
              ></el-checkbox>
            </el-col>
            <el-col :span="12">
              <el-date-picker
                placeholder="辯論補考日期"
                :disabled="!addForm.debate"
                v-model="addForm.debateDate"
                value-format="timestamp"
                type="date"
                style="width: 90%"
              >
              </el-date-picker>
            </el-col>
          </el-row>

          <el-form-item label="備註" style="margin-bottom: -1em"></el-form-item>
          <el-input
            style="margin-bottom: 1em"
            placeholder="請輸入備註"
            v-model="addForm.memo"
          ></el-input>
        </el-row>
        <el-row type="flex" justify="center">
          <el-button @click="closeDialog(true)">取消</el-button>
          <el-button
            v-if="isNaN(id)"
            id="test_lifeClass_btAddgo"
            @click="check"
            type="primary"
            >新增</el-button
          >
          <el-button
            v-else
            id="test_lifeClass_btAddgo"
            @click="check"
            type="primary"
            >儲存</el-button
          >
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
import API from "@/api/";
import Utils from "@/utils";
import { InformType } from "@/utils/InformType";

export default {
  name: "makeUpAdd",
  props: {
    clickTime: Date,
    id: { Number, default: NaN },
    sp: { String, default: "" },
    sc: { Array, default: [] },
  },
  watch: {
    clickTime: function () {
      console.log("clickTime watch");
      console.log("id", this.id);
      console.log("NaN", isNaN(this.id));
      this.query();
      this.getStudyClass();
    },
  },
  created: function () {
    this.query();
    this.getStudyClass();
  },
  data() {
    return {
      isLoading: false,
      studyClass: [],
      addForm: {
        studyPerson:this.sp,
        studyClass: "",
        recite: false,
        reciteDate: null,
        debate: false,
        debateDate: null,
        memo: "",
      },
    };
  },
  methods: {
    query() {
      if (this.id) {
        console.log("讀取");
        this.isLoading = true;
        API.person.makeUpEachShow(this.id).then((res) => {
          console.log(res.data);
          this.addForm = res.data;
          this.isLoading = false;
        });
      } else {
        this.addForm ={
          studyPerson:this.sp,
          studyClass: "",
          recite: false,
          reciteDate: null,
          debate: false,
          debateDate: null,
          memo: "",
        };
      }
    },
    getStudyClass() {
      console.log("讀取學程");
      API.studyYear.getStudyClass().then((res) => {
        this.studyClass = res.data;
        console.log(this.sc);
        this.studyClass = this.studyClass.map((item)=>{
          if(this.sc.findIndex((i) => i === item.studyName)>=0)
            item.disabled =true;
          else   
            item.disabled =false;        
          return item;
        }); 
      });
    },
    closeDialog() {
      this.$emit("close",this.sp );
    },
    check() {
      if (Utils.Check.isNull(this.addForm.studyClass)) {
        Utils.Message.send("學程不能為空!", InformType.ERROR);
        return;
      }
      if (Utils.Check.isNull(this.addForm.debateDate)&&this.addForm.debate) {
        Utils.Message.send("辯論補考日期不能為空!", InformType.ERROR);
        return;
      }
      if (Utils.Check.isNull(this.addForm.reciteDate)&&this.addForm.recite) {
        Utils.Message.send("背書補考日期不能為空!", InformType.ERROR);
        return;
      }
      if (!this.addForm.recite&&!this.addForm.debate) {
        Utils.Message.send("補考項目不能為空!", InformType.ERROR);
        return;
      }
      this.update();
    },
    switchChange(item) {
      if (item == "recite") {
        if (this.addForm.recite) this.addForm.reciteDate = Date.now();
        else this.addForm.reciteDate = null;
      }
      if (item == "debate") {
        if (this.addForm.debate) this.addForm.debateDate = Date.now();
        else this.addForm.debateDate = null;
      }
    },
    update() {
      if (this.id) {
        console.log("修改", this.id, this.addForm);
        this.isLoading = true;
        API.person
          .makeUpEachEdit(this.id, this.addForm)
          .then(() => {
            Utils.Message.send("修改補考成功!", InformType.SUCCESS);
            this.isLoading = false;
            this.closeDialog();
          })
          .catch(() => {
            this.isLoading = false;
          });
      } else {
        console.log("新增");
        this.isLoading = true;
        API.person
          .makeUpEachAdd(this.addForm)
          .then(() => {
            Utils.Message.send("新增補考成功!", InformType.SUCCESS);
            this.isLoading = false;
            this.closeDialog();
          })
          .catch(() => {
            this.isLoading = false;
          });
      }
    },
  },
};
</script>

<style>
</style>